/**
 * Convert snake_case or SCREAMING_SNAKE_CASE codes to Title Case.
 *
 * Examples:
 *   power_tongs       → "Power Tongs"
 *   THREAD_WASH       → "Thread Wash"
 *   torque_monitoring  → "Torque Monitoring"
 *   in_progress        → "In Progress"
 *   APPROVED           → "Approved"
 *   "Power Tongs"      → "Power Tongs" (already clean — returned as-is)
 */
export function humanizeLabel(value: string): string {
  if (!value) return '';

  const hasUnderscore = value.includes('_');
  const isAllUpper = value === value.toUpperCase() && /[A-Z]/.test(value);
  const isAllLower = value === value.toLowerCase() && /[a-z]/.test(value);

  // Already mixed-case with no underscores — leave it alone
  if (!hasUnderscore && !isAllUpper && !isAllLower) return value;

  return value
    .toLowerCase()
    .replace(/_/g, ' ')
    .split(' ')
    .filter(Boolean)
    .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
    .join(' ');
}
